import React, { createContext, useState, useEffect } from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

export const ThemeContext = createContext();

const lightTheme = {
  mode: 'light',
  background: '#f8f6f2',
  text: '#0c0c0c',
  textSecondary: '#6f6f6f',
  card: '#fff9f3',
  navBackground: '#f8f6f2',
  navTextColor: '#0c0c0c',
  accent: '#c41f26', // Prada lipstick red
  muted: '#8d867f',
  line: 'rgba(12,12,12,0.12)',
  tagBg: 'rgba(12,12,12,0.06)',
  tagText: '#4a4a4a',
  selectionBg: 'rgba(200,16,46,0.14)',
  selectionText: '#0c0c0c',
  baseFontSize: '18px',
  font: '"DM Sans", "Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
  headingFont: '"Playfair Display", "DM Sans", "Inter", system-ui, -apple-system, "Segoe UI", serif',
};

const darkTheme = {
  mode: 'dark',
  background: '#0f0f12',
  text: '#f3ede7',
  textSecondary: '#b6b0a9',
  card: '#18171f',
  navBackground: '#0f0f12',
  navTextColor: '#f3ede7',
  accent: '#c41f26', // consistent red for dark
  muted: '#8d867f',
  line: 'rgba(243,237,231,0.12)',
  tagBg: 'rgba(243,237,231,0.08)',
  tagText: '#d8d1c7',
  selectionBg: 'rgba(225,52,69,0.24)',
  selectionText: '#fdfbf8',
  baseFontSize: '18px',
  font: '"DM Sans", "Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
  headingFont: '"Playfair Display", "DM Sans", "Inter", system-ui, -apple-system, "Segoe UI", serif',
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(false);

  // ✅ Read theme from localStorage only on client-side
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    if (stored === 'dark') {
      setIsDark(true);
    }
  }, []);

  // ✅ Update localStorage when theme changes
  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => setIsDark(prev => !prev);

  const theme = isDark ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, theme }}>
      <EmotionThemeProvider theme={theme}>
        {children}
      </EmotionThemeProvider>
    </ThemeContext.Provider>
  );
};
